module.exports = __webpack_public_path__ + "img/icon_mostrar.16eb06d0.svg";